/* ==========================================================================
   HUMO BARRILES · OFERTA RELÁMPAGO
   assets/humo-upsell.js

   Cada producto de la oferta tiene dos identidades: el espejo, que es lo
   que se añade con el precio ya rebajado, y el original, que es lo que el
   cliente puede haber comprado antes. Si ya tiene cualquiera de los dos,
   el producto no aparece en la oferta.
   ========================================================================== */
(function () {
  'use strict';

  var caja = document.querySelector('[data-upsell]');
  var raiz = document.querySelector('[data-preorder-root]');
  if (!caja || !raiz) return;

  var RUTA_CARRITO = raiz.dataset.cartUrl || '/cart';
  var RUTA_ADD = raiz.dataset.cartAddUrl || '/cart/add';

  var OFERTA = [];
  try { OFERTA = JSON.parse(caja.querySelector('[data-upsell-datos]').textContent) || []; } catch (e) {}
  if (!OFERTA.length) return;

  var BARRILES = [];
  try {
    var b = raiz.querySelector('[data-preorder-barrel-ids]');
    if (b) BARRILES = JSON.parse(b.textContent) || [];
  } catch (e) {}

  var lista = caja.querySelector('[data-upsell-lista]');
  var pieTotal = caja.querySelector('[data-upsell-total]');
  var ahorro = 0;
  var yaMostrado = false;

  var carrito = { items: [] };
  function refrescar() {
    return fetch(RUTA_CARRITO + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { carrito = c; return c; })
      .catch(function () { return carrito; });
  }
  refrescar();
  document.addEventListener('humo:carrito-cambio', refrescar);
  var cuerpo = raiz.querySelector('[data-preorder-items]');
  if (cuerpo) new MutationObserver(refrescar).observe(cuerpo, { childList: true, subtree: true });

  function dinero(n) { return '$' + (n / 100).toFixed(2); }

  function idsCarrito() {
    return (carrito.items || []).map(function (it) { return it.variant_id || it.id; });
  }
  function hayBarril() {
    var d = idsCarrito();
    return BARRILES.some(function (id) { return d.indexOf(id) !== -1; });
  }
  function pendientes() {
    var d = idsCarrito();
    return OFERTA.filter(function (o) {
      return d.indexOf(o.vid) === -1 && d.indexOf(o.gemelo) === -1;
    });
  }

  function pintar(items) {
    lista.innerHTML = items.map(function (o) {
      return '' +
        '<article class="hb-up__item" data-up-item="' + o.vid + '" data-up-handle="' + (o.h || '') + '">' +
          '<div class="hb-up__foto">' +
            (o.img ? '<img src="' + o.img + '" alt="' + o.n + '" loading="lazy">' : '') +
          '</div>' +
          '<div class="hb-up__cuerpo">' +
            '<p class="hb-up__nombre">' + o.n + '</p>' +
            '<div class="hb-up__fila-precio">' +
              '<div class="hb-up__precios">' +
                '<s class="hb-up__antes">' + dinero(o.antes) + '</s>' +
                '<span class="hb-up__ahora">' + dinero(o.ahora) + '</span>' +
              '</div>' +
              '<div class="hb-up__cant" data-up-cant>' +
                '<button type="button" data-up-menos aria-label="Less">&minus;</button>' +
                '<input type="number" value="1" min="1" max="5" step="1" inputmode="numeric" aria-label="Quantity" data-up-num>' +
                '<button type="button" data-up-mas aria-label="More">+</button>' +
              '</div>' +
            '</div>' +
            '<button type="button" class="hb-up__add" data-up-add="' + o.vid + '">Add</button>' +
          '</div>' +
          '<div class="hb-up__check" aria-hidden="true">' +
            '<svg viewBox="0 0 60 60"><circle cx="30" cy="30" r="26"/><path d="M18 31l8 8 16-17"/></svg>' +
          '</div>' +
        '</article>';
    }).join('');
  }

  function actualizarTotal() {
    if (!pieTotal) return;
    pieTotal.hidden = ahorro <= 0;
    pieTotal.innerHTML = 'You are saving <b>' + dinero(ahorro) + '</b> with this offer.';
  }

  lista.addEventListener('click', function (ev) {
    var menos = ev.target.closest('[data-up-menos]');
    var mas = ev.target.closest('[data-up-mas]');
    if (menos || mas) {
      ev.stopPropagation();
      var campo = (menos || mas).parentNode.querySelector('[data-up-num]');
      var v = parseInt(campo.value, 10) || 1;
      campo.value = Math.max(1, Math.min(5, v + (menos ? -1 : 1)));
      return;
    }
    if (ev.target.closest('[data-up-num]')) { ev.stopPropagation(); return; }

    var btn = ev.target.closest('[data-up-add]');
    if (btn && !btn.disabled) {
      ev.stopPropagation();
      anadir(btn);
      return;
    }

    /* clic en la tarjeta: abre la ficha del producto original */
    var art = ev.target.closest('[data-up-item]');
    if (!art) return;
    var handle = art.dataset.upHandle;
    if (!handle) return;
    var disparo = raiz.querySelector('[data-preorder-open="' + handle + '"]');
    if (disparo) { disparo.click(); return; }
    var falso = document.createElement('button');
    falso.type = 'button';
    falso.setAttribute('data-preorder-open', handle);
    falso.style.display = 'none';
    raiz.appendChild(falso);
    falso.click();
    setTimeout(function () { falso.remove(); }, 400);
  });

  function anadir(btn) {
    var vid = Number(btn.dataset.upAdd);
    var art = btn.closest('[data-up-item]');
    var campo = art.querySelector('[data-up-num]');
    var cant = Math.max(1, Math.min(5, parseInt(campo.value, 10) || 1));
    var dato = OFERTA.filter(function (o) { return o.vid === vid; })[0];

    btn.disabled = true;
    btn.textContent = 'Adding…';

    fetch(RUTA_ADD + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: vid, quantity: cant }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        art.classList.add('is-hecho');
        btn.textContent = 'Added';
        if (dato) ahorro += (dato.antes - dato.ahora) * cant;
        actualizarTotal();
        refrescar();
        document.dispatchEvent(new CustomEvent('humo:carrito-cambio'));
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'Try again';
      });
  }

  function cerrar() {
    caja.classList.remove('is-abierto');
    document.documentElement.style.overflow = '';
  }
  /* el precio ya viene rebajado en el producto: no hace falta código */
  function alCheckout() { window.location.href = '/checkout'; }
  caja.querySelector('[data-upsell-seguir]').addEventListener('click', alCheckout);

  function volver() {
    cerrar();
    yaMostrado = false;
    ahorro = 0;
    refrescar();
  }
  caja.querySelector('[data-upsell-cerrar]').addEventListener('click', volver);
  caja.addEventListener('click', function (ev) { if (ev.target === caja) volver(); });
  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape' && caja.classList.contains('is-abierto')) volver();
  });

  function abrir(items) {
    pintar(items);
    ahorro = 0;
    actualizarTotal();
    caja.classList.add('is-abierto');
    document.documentElement.style.overflow = 'hidden';
    yaMostrado = true;
  }

  var boton = raiz.querySelector('[data-preorder-checkout]');
  if (!boton) return;
  boton.addEventListener('click', function (ev) {
    if (yaMostrado) return;
    if (!hayBarril()) return;
    var faltan = pendientes();
    if (!faltan.length) return;
    ev.preventDefault();
    ev.stopImmediatePropagation();
    abrir(faltan);
  }, true);
})();
